<template>
    <div>
        <div class="info-grid">
            <div v-if="billingCycle" class="info-item-group list d-flex" :class="(billingCycle || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <img src="../assets/wallet.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block">Billing Cycle:</label>
                    <template v-for="cycle in (billingCycle || '').split(';')">
                        <span :key="cycle" class="d-block">{{ cycle }}</span>
                    </template>
                </div>
            </div>

            <div v-if="aumManagement" class="info-item-group list d-flex" :class="(aumManagement || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <img src="../assets/conference.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block">Management of AUM:</label>
                    <template v-for="aum in (aumManagement || '').split(';')">
                        <span :key="aum" class="d-block">{{ aum }}</span>
                    </template>
                </div>
            </div>

            <div v-if="financialPlans" class="info-item-group list d-flex" :class="(financialPlans || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <CustomIcon name="srg-planning-docs" color="#97C131" />
                <div class="d-inline">
                    <label class="d-block">Number of Financial Plans:</label>
                    <template v-for="plan in (financialPlans || '').split(';')">
                        <span :key="plan" class="d-block">{{ plan }}</span>
                    </template>
                </div>
            </div>

            <!-- built to handle lines separated by a comma, but data entered messed that up -- need more training -->
            <div  v-if="familyAccounts" class="info-item-group list d-flex" :class="(familyAccounts || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <img src="../assets/family.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block">Family Accounts:</label>
                    <template v-for="account in (familyAccounts || '').split(';')">
                        <span :key="account" class="d-block">{{ account }}</span>
                    </template>
                </div>
            </div>

            <div v-if="averageFee" class="info-item-group list d-flex" :class="(averageFee || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <img src="../assets/piggy-bank.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block">{{ insuranceBasedListings.includes(practiceType) ? 'Average Commission' : 'Fee Structure' }}:</label>
                    <template v-for="fee in (averageFee || '').split(';')">
                        <span :key="fee" class="d-block">{{ fee }}</span>
                    </template>
                </div>
            </div>

            <div v-if="openEnrollment" class="info-item-group list d-flex" :class="(openEnrollment || '').split(';').length > 1 ? 'align-start' : 'align-center'">
                <img src="../assets/conference.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block">Open Enrollment:</label>
                    <template v-for="fee in (openEnrollment || '').split(';')">
                        <span :key="fee" class="d-block">{{ fee }}</span>
                    </template>
                </div>
            </div>
            
            <div v-if="showEmptyCell" class="info-item-group empty"></div>
        </div>

        <div v-if="otherNotes" class="d-flex info-item-group list notes pa-0 pt-6">
            <div class="dotted_border flex-grow-1">
                <label class="d-block mt-2 ml-3 flex-grow-1">Other Notes Regarding Revenue</label>
                <span class="d-block my-2 mx-3 flex-grow-1" v-html="otherNotes"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailsRevenueOther',
    props: {
        insuranceBasedListings: {
            type: Array,
            default: []
        },
        practiceType: {
            type: Number,
            default: 1,
        },
        openEnrollment: {
            type: String,
            default: '',
        },
        billingCycle: {
            type: String,
            default: '',
        },
        aumManagement: {
            type: String,
            default: '',
        },
        financialPlans: {
            type: String,
            default: '',
        },
        averageFee: {
            type: String,
            default: '',
        },
        familyAccounts: {
            type: String,
            default: '',
        },
        otherNotes: {
            type: String,
            default: '',
        }
    },

    computed: {
        showEmptyCell () {
            let num = 0;
            if (this.billingCycle != null) num++
            if (this.aumManagement != null) num++
            if (this.financialPlans != null) num++
            if (this.averageFee != null) num++
            if (this.familyAccounts != null) num++
            if (this.openEnrollment != null) num++

            return num % 2 == 0 ? false : true;
        },
    }
}
</script>

<style scoped>
    .info-grid {
        background-color: #EFEFEF;
    }

    .notes {
        margin: 20px 30px;
        padding: 10px;
    }

    .dotted_border {
        border: 2px dashed #97C131;
    }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-revenue/RevenueOther.vue